export default __webpack_public_path__ + "static/media/banner.a15ef238.jpg";